import { apiConfig, initialize } from 'mmfintech-checkout-commons'
import { isLocalhost } from 'mmfintech-commons'

initialize(import.meta.env)

const host = typeof window !== 'undefined' ? window.location.host : ''

const isDevelopment = host.indexOf('-dev.') > -1
const isSandbox = host.indexOf('-sandbox.') > -1
export const isProduction = typeof window !== 'undefined' && !isLocalhost && !isSandbox && !isDevelopment

const settings = {
  backendForLocalhost: 'https://pay-dev.jetonbank.com',
  // backendForLocalhost: 'https://pay-sandbox.jetonbank.com',
  languages: ['en'],
  enableContinueOnMobileButton: apiConfig.VITE_ENABLE_CONTINUE_ON_MOBILE === 'true'
}

export default settings
